module.exports = __webpack_public_path__ + "static/img/welcome-infinite-possibility-24.683b433.png";


//////////////////
// WEBPACK FOOTER
// ./static/welcome-infinite-possibility-24.png
// module id = hGbN
// module chunks = 1